import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";
import moment from "moment";

const initialState = {
    deviceDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    gatewaysDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    roomTypeDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    ratePlanDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    deviceTab: 0,
    roomIdData: [],
    roomRateIdData: [],
    otaRoomRateIdData: [],
    expenseTab: 0,
    expenseCategoryList: [],
    refreshExpenseCategory: false,
    expenseCategoryDataGridOptions: {
      loading: false,
      rows: [],
      totalRows: 0,
      rowsPerPageOptions: rowsPerPageJsonData,
      pageSize: 50,
      page: 1,
    },
    expenseCategorySearchFilters: {
      searchText: "",
    },
    refreshExpenseSubCategory: false,
    expenseSubCategoryList: [],
    expenseSubCategoryDataGridOptions: {
      loading: false,
      rows: [],
      totalRows: 0,
      rowsPerPageOptions: rowsPerPageJsonData,
      pageSize: 50,
      page: 1,
    },
    expenseSubCategorySearchFilters: {
      searchText: "",
    },
    expenseCategorySelectList: [],
    expenseList: [],
    expenseDataGridOptions: {
      loading: false,
      rows: [],
      totalRows: 0,
      rowsPerPageOptions: rowsPerPageJsonData,
      pageSize: 50,
      page: 1,
    },
    expenseSearchFilters: {
      searchText: "",
       startDate: moment().startOf("month").format("YYYY-MM-DD"),
       endDate: moment().endOf("month").format("YYYY-MM-DD"),
    },
};
const managementSlice = createSlice({
  name: "management",
  initialState: initialState,
  reducers: {
    deviceTabSuccess: (state, action) => {
        state.deviceTab = action.payload;
    },
    roomIdDataSuccess: (state, action) => {
        state.roomIdData = action.payload;
    },
    roomRateIdDataSuccess: (state, action) => {
        state.roomRateIdData = action.payload;
    },
    otaRoomRateIdDataSuccess: (state, action) => {
        state.otaRoomRateIdData = action.payload;
    },
    deviceDataGridOptionsSucces: (state, action) => {
    state.deviceDataGridOptions = {...state.deviceDataGridOptions, [action.payload.key]: action.payload.value}
    },
    gatewaysDataGridOptionsSucces: (state, action) => {
    state.gatewaysDataGridOptions = {...state.gatewaysDataGridOptions, [action.payload.key]: action.payload.value}
    },
    roomTypeDataGridOptionsSucces: (state, action) => {
    state.roomTypeDataGridOptions = {...state.roomTypeDataGridOptions, [action.payload.key]: action.payload.value}
    },
    ratePlanDataGridOptionsSucces: (state, action) => {
    state.ratePlanDataGridOptions = {...state.ratePlanDataGridOptions, [action.payload.key]: action.payload.value}
    },
    expenseTabSuccess: (state, action) => {
      state.expenseTab = action.payload;
    },
    expenseCategorySelectListSuccess: (state, action) => {
      state.expenseCategorySelectList = action.payload;
    },
    expenseCategoryListSuccess: (state, action) => {
      state.expenseCategoryList = action.payload;
    },
    expenseCategoryListFailed: (state, action) => {
      state.expenseCategoryList = [];
    },
    refreshExpenseCategorySuccess: (state, action) => {
      state.refreshExpenseCategory = true;
    },
    refreshExpenseCategoryFailed: (state, action) => {
      state.refreshExpenseCategory = false;
    },
    expenseCategoryDataGridOptionsSuccess: (state, action) => {
      state.expenseCategoryDataGridOptions = {...state.expenseCategoryDataGridOptions, [action.payload.key]: action.payload.value}
    },
    expenseCategorySearchFiltersSuccess: (state, action) => {
      state.expenseCategorySearchFilters = {...state.expenseCategorySearchFilters, [action.payload.key]: action.payload.value};
    },
    expenseSubCategoryListSuccess: (state, action) => {
      state.expenseSubCategoryList = action.payload;
    },
    expenseSubCategoryListFailed: (state, action) => {
      state.expenseSubCategoryList = [];
    },
    refreshExpenseSubCategorySuccess: (state, action) => {
      state.refreshExpenseSubCategory = true;
    },
    refreshExpenseSubCategoryFailed: (state, action) => {
      state.refreshExpenseSubCategory = false;
    },
    expenseSubCategoryDataGridOptionsSuccess: (state, action) => {
      state.expenseSubCategoryDataGridOptions = {...state.expenseSubCategoryDataGridOptions, [action.payload.key]: action.payload.value}
    },
    expenseSubCategorySearchFiltersSuccess: (state, action) => {
      state.expenseSubCategorySearchFilters = {...state.expenseSubCategorySearchFilters, [action.payload.key]: action.payload.value};
    },
    expenseListSuccess: (state, action) => {
      state.expenseList = action.payload;
    },
    expenseListFailed: (state, action) => {
      state.expenseList = [];
    },
    expenseDataGridOptionsSuccess: (state, action) => {
      state.expenseDataGridOptions = {...state.expenseDataGridOptions, [action.payload.key]: action.payload.value}
    },
    expenseSearchFiltersSuccess: (state, action) => {
      state.expenseSearchFilters = {...state.expenseSearchFilters, [action.payload.key]: action.payload.value};
    },
  },
});

export const {
    deviceTabSuccess,
    deviceDataGridOptionsSucces,
    gatewaysDataGridOptionsSucces,
    roomTypeDataGridOptionsSucces,
    ratePlanDataGridOptionsSucces,
    roomIdDataSuccess,
    roomRateIdDataSuccess,
    otaRoomRateIdDataSuccess,
    expenseTabSuccess,
    expenseCategoryListSuccess,
    expenseCategoryListFailed,
    refreshExpenseCategorySuccess,
    refreshExpenseCategoryFailed,
    expenseCategoryDataGridOptionsSuccess,
    expenseCategorySearchFiltersSuccess,
    expenseSubCategoryListSuccess,
    expenseSubCategoryListFailed,
    refreshExpenseSubCategorySuccess,
    refreshExpenseSubCategoryFailed,
    expenseSubCategoryDataGridOptionsSuccess,
    expenseSubCategorySearchFiltersSuccess,
    expenseListSuccess,
    expenseListFailed,
    expenseDataGridOptionsSuccess,
    expenseSearchFiltersSuccess,
    expenseCategorySelectListSuccess,
} = managementSlice.actions;
export default managementSlice.reducer;
